import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  backButton: {
    display: "flex",
    justifyContent: "center",
  },
  alignCenter: {
    textAlign: "center",
  },
  content: {
    maxWidth: 520,
  },
  message: {
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
});

const ErrorModal = ({ open, title, errorText, handleClose, actionHref, actionLabel }) => {
  const classes = useStyles();

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.alignCenter} id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent className={classes.content}>
          <DialogContentText
            className={classes.alignCenter}
            id="alert-dialog-description"
          >
            <span className={classes.message}>{errorText}</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.backButton}>
          {actionHref && (
            <Button
              variant="outlined"
              color="primary"
              href={actionHref}
              target="_blank"
              rel="noopener noreferrer"
            >
              {actionLabel || "Continue"}
            </Button>
          )}
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={handleClose}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default ErrorModal;
